<template>
    <f7-page
        name="Next Up"
        class="withHalfBg"
    >
        <f7-navbar
            :title-large="`Pick what's next`"
            large
            no-hairline
            large-transparent
        >
            <f7-nav-left>
                <f7-link
                    v-if="fromHome"
                    icon="ion-ios-arrow-left"
                    back
                />
            </f7-nav-left>
            <f7-nav-title>Pick what's next</f7-nav-title>
            <f7-nav-right>
                <f7-link
                    v-if="!fromHome"
                    href="#"
                    style="padding-right: 10px"
                    @click="closePopup"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                    >
                        <g
                            fill="none"
                            fill-rule="evenodd"
                            stroke="gray"
                            stroke-linecap="square"
                            stroke-width=".75"
                            transform="translate(-2)"
                        >
                            <path d="M3,1 L18,16" />
                            <path
                                d="M4.29545455,0.293103448 L16.7045455,16.7068966"
                                transform="rotate(78 10.5 8.5)"
                            />
                        </g>
                    </svg>
                </f7-link>
            </f7-nav-right>
        </f7-navbar>
        <br><br>

        <next-up
            :course-id="user.currentCourseId"
            :key="user.currentCourseId"
            :in-popup="this.$f7router.view.name !== 'main' ? this.$f7router.view.name : ''"
        />

    </f7-page>
</template>

<script>
import NextUp from '../../components/nextUp.vue';

export default {
    store: ['api', 'user', 'fullDataIndex', 'coursesIndex'],
    components: {
        NextUp
    },
    data () {
        return {
            currentId: 0,
            fromHome: false,
        };
    },
    created: function () {
        if (this.$f7route.params.id) {
            this.currentId = parseFloat(this.$f7route.params.id);
        }
        if (this.$f7route.query.fromHome) {
            this.fromHome = true;
        }
    },
    mounted: function () { },
    methods: {
        closePopup: function () {
            if (this.$f7router.view.main) {
                f7.views['main'].router.navigate('/home', { clearPreviousHistory: true, animatePages: true, transition: 'f7-fade' });
            } else {
                if (f7.popup.get(`#${this.$f7router.view.name}`)) {
                    f7.popup.get(`#${this.$f7router.view.name}`).open();
                    f7.popup.get(`#${this.$f7router.view.name}`).close();
                }
            }
            if (!pgap) window.history.pushState(null, "", '/web' + f7.views['main'].router.currentRoute.path);
        },
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.center {
    text-align: center;
}
#upNext {
    background: #f3f3f3;
    border-top: 30px solid white;
    border-bottom: 30px solid white;
    width: 100%;
    .bigTile {
        margin: -22px auto;
    }
}
</style>
